module.exports = __webpack_public_path__ + "static/media/XVS.7e506543.svg";